export class EventEmitter {
  _eventHandlers = new Map();

  destroy() {
    this._eventHandlers.clear();
  }

  fire(eventName, ...args) {
    let handlers = this._eventHandlers.get(eventName);
    if (handlers) {
      handlers.forEach(i => i.apply(null, args));
    }
  }

  on(eventName, callback) {
    let handlers = this._eventHandlers.get(eventName);
    if (!handlers) {
      handlers = new Set();
      this._eventHandlers.set(eventName, handlers);
    }

    handlers.add(callback);
  }

  once(eventName, callback) {
    const cb = (...args) => {
      this.off(eventName, cb);
      callback.apply(null, args);
    };

    this.on(eventName, cb);
  }

  off(eventName, callback) {
    let handlers = this._eventHandlers.get(eventName);
    if (!handlers) {
      handlers = new Set();
      this._eventHandlers.set(eventName, handlers);
    }

    handlers.delete(callback);
  }
}
